import V from 'voUtils/V.js';

import {
	isBlank,
	objectIsSimilar
}
from 'voUtils/tools.js';

import {
	fireSearch
}
from 'voUtils/TagEx.js';

import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	getVoucher
}
from 'voUtils/VoucherStore.js';
import {
	getAbTest
}
from 'voUtils/AbTest.js';

import {
	getFavIds
}
from 'voUtils/FavStore.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';


export default {
	data: {
		mapItems: [{
			"_id": 1,
			"sectionid": "aalundfischrauchereifoh",
			"name": "Aal- und Fischräucherei Föh - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.93332434110442, 54.66285033852817]
			}
		}, {
			"_id": 2,
			"sectionid": "asianudelwok",
			"name": "Asia Nudel Wok - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.932807317791163, 54.66105795104042]
			}
		}, {
			"_id": 3,
			"sectionid": "fischrauchereiwolter",
			"name": "Fischräucherei Wolter - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.950894317791162, 54.653761564543004]
			}
		}, {
			"_id": 4,
			"sectionid": "grillmaxx",
			"name": "GrillMaxx - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.93082467055221, 54.66131795098954]
			}
		}, {
			"_id": 5,
			"sectionid": "mcdonalds",
			"name": "McDonalds - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.945507521486183, 54.65681018595357]
			}
		}, {
			"_id": 6,
			"sectionid": "veneziapizzaexpress",
			"name": "Venezia Pizza Express - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.931604341104421, 54.66073689039696]
			}
		}, {
			"_id": 7,
			"sectionid": "ziegenhofrehder",
			"name": "Ziegenhof Rehder - Auf Die Schnelle",
			"loc": {
				"coordinates": [10.135762011656631, 54.24618842383255]
			}
		}, {
			"_id": 8,
			"sectionid": "datfischhuus",
			"name": "Dat Fischhuus - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.83645601165663, 54.47459220822431]
			}
		}, {
			"_id": 9,
			"sectionid": "mehrfisch",
			"name": "Mehrfisch - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.841057670552209, 54.47387854619359]
			}
		}, {
			"_id": 10,
			"sectionid": "momonaturbutik",
			"name": "MOMO Naturbutik - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.43115609266104, 54.7915428995665]
			}
		}, {
			"_id": 11,
			"sectionid": "fahrhauslacafesubesplatzchen",
			"name": "Fährhaus LA & Café Süßes Plätzchen - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.65444067055221, 54.82160223751746]
			}
		}, {
			"_id": 12,
			"sectionid": "dingholzerhofkiosk",
			"name": "Dingholzer Hofkiosk - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.715629813493923, 54.74459715815167]
			}
		}, {
			"_id": 13,
			"sectionid": "hofladenmangelsen",
			"name": "Hofladen Mangelsen - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.670515976686742, 54.78585224657793]
			}
		}, {
			"_id": 14,
			"sectionid": "timmserdbeerhof",
			"name": "Timm’s Erdbeerhof - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.82974601165663, 54.75523754564156]
			}
		}, {
			"_id": 15,
			"sectionid": "udosimbissamhafen",
			"name": "Udo’s Imbiss am Hafen - Auf Die Schnelle",
			"loc": {
				"coordinates": [9.993058999999999, 54.68257333447928]
			}
		}],
	},
	beforeMount: function () {

	},
	updated: function () {

	},
	computed: {

	},
	watch: {

	}

};